<template>
  <div>
    <section class="business-bg">
      <div class="container shape-container pt-md-5">
        <div class="pt-md-8">
          <div class="col-lg-8 pt-5">
            <div class="row">
              <h3 class="display-3 mt-5">
                Power Your Digital Channels with TopupBox APIs
              </h3>

              <p
                class="lead text-dark mt-3 mb-4"
                style="
                  max-width: 600px;
                  line-height: 1.7;
                  font-size: 1.1rem;
                  color: #333;
                "
              >
                TopupBox enables banks and fintechs to deliver airtime, data,
                and utility payments directly within their own platforms. With
                our secure and well-documented APIs, you can integrate fast,
                scale effortlessly, and provide seamless digital services to
                your customers.
              </p>

              <!-- buttons -->
              <div class="d-flex ml-5" style="gap: 4px">
                <!-- get started button -->
                <div class="btn-wrapper">
                  <a
                    href="https://developer.topupbox.com"
                    target="_blank"
                    class="btn btn-info"
                  >
                    Use API now
                  </a>

                  <!-- talk to sales -->
                  <button
                    type=""
                    class="btn btn-info"
                    @click="showSalesModal = true"
                  >
                    Talk to sales
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--talk to sales Modal -->
    <modal
      :show.sync="showSalesModal"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <!-- header slot -->
      <template #header>
        <h5 class="modal-title">Talk to Sales</h5>
      </template>

      <!-- body slot -->
      <div class="">
        <p class="footer-header d-flex align-items-center" style="gap: 8px">
          <img src="img/icons/common/email.svg" alt="" style="width: 25px" />
          <a href="mailto:sales@topupbox.com">Sales@topupbox.com</a>
        </p>
        <p
          class="footer-header d-flex align-items-center gap-4"
          style="gap: 8px"
        >
          <img
            src="img/icons/common/telephone.png"
            alt=""
            style="width: 25px"
          />
          <a href="tel:+2348123456789">08081100427</a>
        </p>
      </div>
    </modal>
    <section class="section px-lg-0 px-4">
      <div class="container">
        <div class="row row-grid align-items-center pb-md-5">
          <div
            class="col-md-6 order-md-2"
            data-aos="fade-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <div class="pl-md-5">
              <div class="mb-4">
                <img src="img/icons/common/enterprise.svg" class="img-fluid" />
              </div>
              <p class="display-4 text-default">
                Why TopupBox for Banks & Fintechs?
              </p>
              <ul>
                <li class="py-2">
                  <span class="footer-header"> Expand Your Services</span> -
                  Offer airtime, data bundles, and bill payments directly from
                  your mobile app, website, or banking platform.
                </li>
                <li class="py-2">
                  <span class="footer-header"> Seamless API Integration </span>
                  - Our APIs are reliable, secure, and easy to implement,
                  whether you’re a tech team or working with contracted
                  developers.
                </li>
                <li class="py-2">
                  <span class="footer-header"> Boost Customer Engagement</span>
                  - Keep users on your platform by giving them everything they
                  need in one place.
                </li>
                <li class="py-2">
                  <span class="footer-header"> Trusted Infrastructure</span> -
                  Bank-grade reliability ensures every transaction is safe and
                  efficient.
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order-md-1">
            <img
              src="img/theme/banks-hero.png"
              class="img-fluid rounded shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="pb-5 px-lg-0 px-4">
      <div class="container">
        <div class="text-center justify-content-center">
          <div class="col-lg-12">
            <h2 class="display-3 text-default mb-4">How It Works</h2>
          </div>
        </div>
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <div
              class="row row-grid mt-5"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="1000"
            >
              <!-- Sign Up & Access APIs -->
              <div class="col-lg-4 d-flex">
                <card
                  class="border-0 text-center w-100 h-100"
                  shadow
                  body-classes=""
                >
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-key-25 text-primary display-3"></i>
                  </div>
                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Sign Up & Access APIs
                  </h6>
                  <p class="description mt-3">
                    Register with TopupBox and get direct access to our robust
                    API documentation.
                  </p>
                </card>
              </div>
              <!-- Integrate Into Your Systems -->
              <div class="col-lg-4 d-flex">
                <card
                  class="border-0 text-center w-100 h-100"
                  shadow
                  body-classes=""
                >
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-laptop text-primary display-3"></i>
                  </div>
                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Integrate Into Your Systems
                  </h6>
                  <p class="description mt-3">
                    Plug our airtime, data, and utility services into your apps,
                    web platforms, or internal systems.
                  </p>
                </card>
              </div>
              <!-- Launch & Grow -->
              <div class="col-lg-4 d-flex">
                <card
                  class="border-0 text-center w-100 h-100"
                  shadow
                  body-classes=""
                >
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-chart-bar-32 text-primary display-3"></i>
                  </div>
                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Launch & Grow
                  </h6>
                  <p class="description mt-3">
                    Deliver instant digital services to your customers - and
                    keep scaling without limits.
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container mt-5 mb-5">
        <div class="text-center justify-content-center mb-5">
          <h2 class="display-3 text-dark">Built for Developers</h2>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-5 order-md-2">
            <img
              src="img/theme/secure.png"
              class="img-fluid rounded shadow-lg floating"
            />
          </div>
          <div
            class="col-md-6 order-md-1"
            data-aos="fade-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
          >
            <div class="pr-md-5">
              <p>Our developer resources make integration easy</p>
              <ul class="list-unstyled mt-4">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="primary"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">Clear, step-by-step API documentation</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="primary"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">Sandbox for testing before going live</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="primary"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">Reliable support when you need it</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Modal from "../../components/Modal.vue";
export default {
  components: { Modal },
  data() {
    return {
      showSalesModal: false,
    };
  },
};
</script>
<style></style>
